import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background-color: white;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 3;
	box-sizing: border-box;
	justify-content: space-around;
	padding: 0% 0 30% 0;
`;

export const TopWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 30px;
`;

export const Title = styled.div`
	color: var(--Text-color, #29185e);
	text-align: center;
	font-family: 'Work Sans';
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
	line-height: 140%; /* 28px */
`;

export const Icon = styled.div`
	color: #fff;
	font-family: 'Work Sans';
	font-size: 50px;
	font-style: normal;
	font-weight: 400;
	line-height: 140%; /* 70px */
`;

export const Text = styled.div`
	color: var(--Text-color, #29185e);
	text-align: center;
	font-family: 'Work Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 130%; /* 18.2px */
	width: 80%;
`;
